<template>
  <!-- 서비스 페이지 -->
  <div v-if="!$route.path.includes('/admin')" class="vhp-container" :class="$utils.isMobile() ? 'mobile-app' : ''">
    <vhp-admin-header v-if="$store.state.isAdmin" />

    <header class="vhp-header" :class="{ [headerMode]: headerMode }">
      <vhpHeader
        v-if="$route.path === '/' || $route.path === '/technology'"
        :menus="menus.filter((e) => !e.hide)"
        :headerMode="headerMode"
      />
      <vhpHeader v-else :menus="menus.filter((e) => !e.hide)" />
    </header>

    <main class="vhp-main">
      <router-view
        class="vhp-main-content container-width"
        :class="{ 'pb-0': $route.path === '/' }"
      />
    </main>

    <footer class="vhp-footer" v-if="$route.path !== '/error'">
      <vhpFooter :menus="menus.filter((e) => !e.hide)" />
    </footer>


    <div
      class="vhp-floating-button"
      data-aos="fade-down"
      v-if="scrollUpBtn"
      @click="onScrollUp"
    >
      <img src="@/assets/image/arrow-up.svg"/>
    </div>

    
    <div
      v-if="false"
      class="vhp-service-button"
      :class="{active: serviceShow}"
    >
      <div class="content"  
        @click.stop="onClickService"
        
      >
        <img v-if="!serviceShow" src="@/assets/image/vridge-logo.png"/>
        <h3 v-if="!serviceShow">{{$t('바로가기')}} </h3>


        <i v-if="serviceShow" class="fas fa-close" style="font-size:1.3rem;"/>
      </div>

      <div  v-for="(item, idx) in services" :key="item.title" >
        <div class="service" 
          :class="[serviceShow ? 'show' : '', 's' + idx]"
          
          @click.stop="onClickServiceItem(item)"
        >
          <img :src="item.image"/>
          <p>
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>

    <!-- <ChannelTalk v-if="!$store.state.isAdmin" /> -->
  </div>

  <!-- 관리자 페이지 -->
  <div v-else class="vhp-container">
    <header>
      <vhp-admin-header v-if="$store.state.isAdmin" />
    </header>

    <main class="vhp-main no-header">
      <router-view class="vhp-main-content container-width" />
    </main>
  </div>
</template>

<script>
import vhpAdminHeader from "@/components/vhpAdminHeader.vue";
import vhpHeader from "@/components/vhpHeader.vue";
import vhpFooter from "@/components/vhpFooter.vue";
// import ChannelTalk from "@/components/channeltalk/ChannelTalk.vue";

export default {
  name: "App",
  components: {
    vhpAdminHeader,
    vhpHeader,
    vhpFooter,
    // ChannelTalk,
  },
  data() {
    return {
      serviceShow:false,
      menus: [
        {
          text: "바질컴퍼니",
          key: "info",
          path: "/info",
          childrens: [
            {
              text: "회사소개",
              key: "vazil",
              path: "/info/vazil",
            },
            {
              text: "수상/인증",
              key: "awards",
              path: "/info/awards",
            },
            {
              text: "주요특허",
              key: "patent",
              path: "/info/patent",
            },
          ],
        },
        {
          text: "기술과 서비스",
          key: "service",
          path: "/service",
          childrens: [
            {
              text: "용접로봇",
              key: "welding",
              path: "/content?id=@content-1iepgkj24u2bb&list=/service",
            },
            {
              text: "산업용 로봇 자동화",
              key: "industry",
              path: "/content?id=@content-qy4y6lfq53ch&list=/service",
            },
            {
              text: "산업용 로봇 비전",
              key: "vision",
              path: "/content?id=@content-1hrggz2d46a7s&list=/service",
            },
            {
              text: "브릿지 AI",
              key: "vridge",
              path: "/content?id=63b50e864a12ff6f878ae04b&list=/service",
            },
            {
              text: "공정 모니터링 솔루션",
              key: "monitoring",
              path: "/content?id=@content-ts2ggs9s8j79&list=/service",
            },
          ],
          hide: true,
        },
        {
          text: "제품",
          key: "products",
          path: "/products",
          childrens: [{
            text: "자동화 솔루션",
            key: "automatic",
            path: "/products?index=0",
          },{
            text: "지멘스 DM 솔루션",
            key: "simens",
            path: "/products?index=1",
          },{
            text: "통합 S/W 솔루션",
            key: "integration",
            path: "/products?index=2",
          },{
            text: "인공지능 통합 솔루션",
            key: "ai",
            path: "/products?index=3",
          }],
        },

        {
          text: "기술",
          key: "technology",
          path: "/technology",
          childrens: [],
        },
        {
          text: "로봇",
          key: "robot",
          path: "/robot/product",
          childrens: [],
          hide: true,
        },
        {
          text: "소식",
          key: "news",
          path: "/news",
          childrens: [
            {
              text: "스토리",
              key: "story",
              path: "/news/story",
            },
            {
              text: "블로그",
              key: "blog",
              path: "/news/blog",
            },
            {
              text: "공지사항",
              key: "notice",
              path: "/news/notice",
            },
            {
              text: "자료실",
              key: "resources",
              path: "/news/resources",
            },
            {
              text: "채용",
              key: "career",
              path: "/news/career",
              childrens: [],
            },
          ],
        },
        {
          text: "문의하기",
          key: "contact",
          path: "/contact",
          childrens: [],
        },
      ],

      pageTitle: "",
      pageTitleElements: [],
      scrollDown: false,
      scrollUpBtn: false,
      scrollPosY: 0,
      headerTop: 300,
      headerMode: "transparent",

      headerMaintains: ["/technology"],

      services:[{
        title:'AI',
        url:'https://demo.vridgeai.com',
        image:require('@/assets/image/vridge-logo.png')
      },{
        title:'Twin',
        url:'https://rms.vazilcompany.com/s/66b2cfab76a73f247375c312',
        image:require('@/assets/image/vridge-logo.png')
      },{
        title:'Keeper',
        path:'/products/details?id=@product-1722425305631',
        image:require('@/assets/image/vridge-logo.png')
      },{
        title:'DAS',
        path:'/products/details?id=@product-1722425339069',
        image:require('@/assets/image/vridge-logo.png')
      }]
    };
  },

  mounted() {
    window.addEventListener("scroll", this.scrollEvent);

    this.findPageTitle();
    this.setHeaderScroll();
    this.setLanguage();
    // this.drawBackground()
    this.sendVisit();
    this.checkIsAdmin();
    this.onScrollUp();
    this.initProductMenu()
  },

  unmounted() {
    window.removeEventListener("scroll", this.scrollEvent);
  },

  watch: {
    $route() {
      this.findPageTitle();
      this.setHeaderTop();
      this.setHeaderScroll();
      this.setLanguage();
    },
  },
  methods: {
    setLanguage() {
      if (this.$route.query.lang) {
        this.$utils.setCookie("vhp.locale", this.$route.query.lang, 7);
      }
      this.$i18n.locale = this.$utils.getCookie("vhp.locale") || "kr";
    },

    async initProductMenu() {
      for(let menu of this.menus) {
        if(menu.key === 'products') {
          
          const response = await this.$axios.get('/category').catch(err=>{console.log(err); return null})

          menu.childrens = []

          if(!response || !response.data) {
            return
          }

          for(let item of response.data) {
            menu.childrens.push({
              text:item.name,
              key: item.id,
              path:'/products?index=' + item.order
            })
          }

          // childrens: [{
          //   text: "로봇 솔루션",
          //   key: "robot",
          //   path: "/products?index=0",
          // },{
          //   text: "S/W 솔루션",
          //   key: "sw",
          //   path: "/products?index=1",
          // },{
          //   text: "통합 솔루션",
          //   key: "integration",
          //   path: "/products?index=2",
          // }],
          break
        }
      }
    },

    drawBackground() {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = window.innerWidth;
      canvas.height = document.body.offsetHeight;

      ctx.font =
        "32px bold Apple SD Gothic Neo, Pretendard-Regular, NotoSansKR, sans-serif ";
      ctx.textBaseline = "middle";
      ctx.textAlign = "center";
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = "#C4182805";
      ctx.beginPath();
      ctx.moveTo(canvas.width * 0.6, 0);
      ctx.lineTo(canvas.width, 0);
      ctx.lineTo(canvas.width, canvas.height * 0.8);
      ctx.fill();

      ctx.fillStyle = "#C4182803";
      ctx.beginPath();
      ctx.moveTo(canvas.width * 0.6, canvas.height);
      ctx.lineTo(canvas.width, canvas.height);
      ctx.lineTo(canvas.width, canvas.height * 0.5);
      ctx.fill();
      let src = canvas.toDataURL("image/png", 1.0);

      document.body.style.backgroundImage = "url(" + src + ")";
    },
    
    onClickService(){
      this.serviceShow = !this.serviceShow 
    },

    onClickServiceItem(item) {
      if(item.path){
        this.$router.push(item.path)
        
      } else if(item.url) {
        this.$utils.openLink(item.url)
      }
      this.serviceShow = false
    },

    scrollEvent() {
      this.setHeaderScroll();
    },

    findPageTitle() {
      setTimeout(() => {
        this.pageTitleElements = [];
        for (let elem of document.getElementsByClassName("page-title")) {
          let title = {
            html: elem.innerHTML,
            position: Math.ceil(elem.offsetTop),
          };
          this.pageTitleElements.push(title);
        }
      }, 500);
    },

    setPageTitle(scrollPosY) {
      if (!scrollPosY) {
        this.pageTitle = "";
        return;
      }

      for (let i = 0; i < this.pageTitleElements.length; i++) {
        if (scrollPosY >= this.pageTitleElements[i].position) {
          this.pageTitle =
            this.pageTitleElements[i].html || this.$t("바질컴퍼니");
          return;
        }
      }
      this.pageTitle = this.$t("바질컴퍼니");
    },

    setHeaderTop() {
      setTimeout(() => {
        const ht = document.getElementById("header-top");
        if (ht) {
          this.headerTop = ht.getBoundingClientRect().top || 300;
        } else {
          this.headerTop = 300;
        }
      }, 500);
    },

    setHeaderScroll() {
      this.headerMode = "transparent";
      let scrollPosY = window.pageYOffset || document.documentElement.scrollTop;
      let viewportHeight = window.innerHeight;
      if (scrollPosY > viewportHeight / 4) {
        if (!this.headerMaintains.includes(this.$route.path)) {
          this.headerMode = "white";
        }
        this.scrollUpBtn = true;
      } else {
        if (!this.headerMaintains.includes(this.$route.path)) {
          this.headerMode = "transparent";
        }
        this.scrollUpBtn = false;
      }

      if (this.headerTop > scrollPosY) {
        this.scrollDown = false;
        this.setPageTitle();
        return;
      }

      if (this.scrollPosY < scrollPosY) {
        this.scrollDown = true;
        this.setPageTitle(scrollPosY);
      } else {
        this.scrollDown = false;
        this.setPageTitle();
      }

      this.scrollPosY = scrollPosY;
    },

    onScrollUp() {
      window.scroll({
        behavior: "smooth",
        left: 0,
        top: 0,
      });

      setTimeout(() => {
        this.scrollDown = false;
      }, 100);
    },

    sendVisit() {
      if (!this.$utils.getCookie("vhp.visit")) {
        const dateKey = new Date()
          .toLocaleDateString("ko-KR")
          .replaceAll(".", "")
          .replaceAll(" ", "");
        this.$axios
          .post("/visit", {
            date: dateKey,
          })
          .then(() => {
            this.$utils.setCookie("vhp.visit", true, 1);
          });
      }
    },

    checkIsAdmin() {
      // frontToken 없을 경우 관리자 페이지 접근 불가
      if (!this.$store.state.frontToken) {
        this.$store.commit("setIsAdmin", false);
        return;
      }

      // frontToken 검증 통과 시 isAdmin 할당, axios headers에 apiToken 할당
      const decryptedText = this.$CryptoJS.AES.decrypt(
        this.$store.state.frontToken,
        process.env.VUE_APP_SECRET_KEY
      ).toString(this.$CryptoJS.enc.Utf8);
      if (decryptedText === process.env.VUE_APP_VALIDATION_TEXT) {
        this.$store.commit("setIsAdmin", true);
        this.$axios.defaults.headers.common["Authorization"] =
          this.$store.state.apiToken;
      }
    },
  },
};
</script>

<style lang="scss" src="./App.scss"></style>
